import React, { FC, ReactNode } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';
import { StyledAnchor, StyledAnchorText } from './SideNavAnchor.styles';

export interface SideNavAnchorProps extends WithAnalytics, SCP<'a'> {
  children?: ReactNode;
}

const SideNavAnchor: FC<SideNavAnchorProps> = ({ children, ...props }) => (

  <StyledAnchor
    tabIndex={0}
    data-testid="SideNavAnchor"
    {...props}
  >
    <StyledAnchorText>{children}</StyledAnchorText>
  </StyledAnchor>
);

export default SideNavAnchor;
